<template>
  <div>
    <topbar
      :titulo="$t('FINANCEIRO.RELATORIO_DECLARACAO_IMPOSTO_RENDA')"
      :subtitulo="$t('FINANCEIRO.RELATORIO_DECLARACAO_IMPOSTO_RENDA_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    />

    <b-row>
      <b-col md="3">
        <input-select-search
          ref="anoLetivoId"
          v-model="localFiltro.anoLetivoId"
          :label="$t(`ACADEMICO.ANO_LETIVO`)"
          :options="opcoes.anosLetivos"
          @input="listarContratosPorAnoLetivo"
          required
        />
      </b-col>
      <b-col md="3" v-if="tipoFiltro === 0">
        <input-select-search
          ref="matriculaId"
          v-model="localFiltro.matriculaId"
          :label="$t(`ACADEMICO.MATRICULAS`)"
          :options="opcoes.matriculas"
          required
        />
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro mb-3 w-100"
          variant="info"
          @click="filtrar"
          v-if="podeVisualizar"
        >
          {{ $t('GERAL.GERAR_RELATORIO') }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro w-100"
          variant="secondary"
          @click="limparFiltro"
        >
          {{ $t('GERAL.LIMPAR') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
    
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import pdf from '@/common/utils/pdf';
import breadcrumb from '@/common/utils/breadcrumb';
import { InputSelectSearch } from '@/components/inputs';
import helpers from '@/common/utils/helpers';

// Services:
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import ContratoService from '../../../../common/services/contratos/contratos.service';
import FluxoCaixaService from '@/common/services/fluxo-caixa/fluxo-caixa.service.js';
import Permissoes from '@/components/mixins/permissoes';
// Components:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  name: 'RelatorioIrmaos',
  mixins: [Permissoes],
  data() {
    return {
      tipoFiltro: 0,
      localFiltro: {
        anoLetivoId: '',
        matriculaId: '',
      },
      opcoes: {
        anosLetivos: [],
        matriculas: [],
      },
      breadcrumbs: [
        { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
        { titulo: this.$t('FINANCEIRO.RELATORIOS') },
        { titulo: this.$t('FINANCEIRO.RELATORIO_DECLARACAO_IMPOSTO_RENDA') },
      ],
    }
  },
  components: {
    Topbar,
    InputSelectSearch,
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
      { titulo: this.$t('FINANCEIRO.RELATORIO_DECLARACAO_IMPOSTO_RENDA') },
    ]);

    this.listarAnosLetivos();
  },
  methods: {
    gerarRelatorioPdf() {
      this.$store.dispatch(START_LOADING);
      const matriculaId = this.localFiltro.matriculaId;
      const anoLetivoId = this.localFiltro.anoLetivoId;

      FluxoCaixaService.gerarImpostoDeRendaPdf(matriculaId, anoLetivoId)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);
            let blob = new Blob([bytes], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarContratosPorAnoLetivo() {
      this.$store.dispatch(START_LOADING);
      ContratoService.buscarContratosPorAnoLetivo(this.localFiltro.anoLetivoId)
        .then(({ data }) => {
          if (data.length) {
            data = data.map((row) => {
              return {
                ...row,
                text: `${row.codigoMatricula} - ${row.nome}`,
                value: row.matriculaId,
              };
            });
            this.opcoes.matriculas = data;
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarAnosLetivos() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar()
        .then(({ data }) => {
          data = data.map((row) => {
            return {
              ...row,
              text: row.ano,
              value: row.id,
            };
          });

          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },
    filtrar() {
      if (!this.validarFiltro()) return;
      this.gerarRelatorioPdf();
    },
    limparFiltro() {
      this.localFiltro = {
        anoLetivoId: '',
        matriculaId: '',
        somentePagamentosEmDia: false,
      };
      this.$emit('limpar', this.localFiltro);
    },
  },
};
</script>
    